import ReactDOMServer from 'react-dom/server'
import React from 'react'
import { functions } from 'utils/firebase'
import store from 'store/store'
import { setError } from 'store/actions'

var toRecipients, subject, messageContent
var type, photo, reportedData, rejectedBy, reason

const sendEmail = async (_type, _reportedData, _photo, _rejectedBy, _reason) => {
  type = _type
  reportedData = _reportedData
  photo = _photo
  rejectedBy = _rejectedBy
  reason = _reason

  toRecipients = createToRecipientList()
  subject = type === 'reject' ? `Your request to have a photo deleted was rejected` : `Photo deleted`
  messageContent = createMessageContent()

  if (toRecipients) return await sendMailViaCloudFunction()
}

function createMessageContent() {
  return ReactDOMServer.renderToStaticMarkup(
    <html
      style={{
        height: '100% !important',
        width: 'auto !important',
        margin: '0 auto !important',
        padding: '0 !important'
      }}
    >
      <head>
        <link href='https://fonts.googleapis.com/css?family=Roboto' rel='stylesheet' />
      </head>
      <body
        style={{
          height: '100% !important',
          width: 'auto !important',
          margin: '0 auto !important',
          padding: '10px 10px !important',
          msoLineHeightRule: 'exactly',
          lineHeight: '90%',
          fontFamily: 'Roboto, Arial'
        }}
      >
        <table
          id='body'
          style={{
            height: '100%',
            width: '100%',
            tableLayout: 'fixed'
          }}
        >
          <tbody>
            <tr>
              <td>
                <table
                  id='container'
                  style={{
                    width: '100%',
                    maxWidth: '1000px',
                    backgroundColor: '#e0dede',
                    fontSize: '14px',
                    color: '#57575a',
                    border: '2px solid #57575a',
                    borderCollapse: 'collapse',
                    tableLayout: 'fixed'
                  }}
                >
                  <tbody>
                    <tr>
                      <td>
                        <table
                          id='title'
                          style={{
                            tableLayout: 'fixed',
                            width: '100%',
                            backgroundColor: '#e0dede',
                            border: '0',
                            borderCollapse: 'collapse',
                            fontSize: '22px',
                            color: '#57575a'
                          }}
                        >
                          <tbody>
                            <tr style={{ height: '40px' }}>
                              <td style={{ width: '20px' }}></td>
                              <td>
                                <strong>{type === 'reject' ? `Your request to have a photo deleted was rejected` : `Your request to have a photo deleted was approved`}</strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <table
                          style={{
                            backgroundColor: '#f4f4f4',
                            tableLayout: 'fixed',
                            border: '0',
                            borderCollapse: 'collapse',
                            width: '100%',
                            color: '#57575a'
                          }}
                          id='body'
                        >
                          <tbody>
                            <tr>{renderBody()}</tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <table
                          id='footer'
                          style={{
                            backgroundColor: '#e0dede',
                            width: '100%',
                            cellPadding: '0',
                            cellSpacing: '0',
                            border: '0',
                            borderCollapse: 'collapse',
                            tableLayout: 'fixed',
                            padding: '0',
                            margin: '0'
                          }}
                        >
                          <tbody>
                            <tr>
                              <td style={{ width: '40px' }}>
                                <a href='https://ujdml.co.za/' style={{ textDecoration: 'none' }}>
                                  <img
                                    src='https://ujdml.co.za/icon-72x72.png'
                                    height='40'
                                    width='40'
                                    style={{ height: '40px', padding: '0', margin: '0' }}
                                    alt='uj-logo'
                                  />
                                </a>
                              </td>
                              <td style={{ width: '6px' }}></td>
                              <td style={{ paddingTop: '6px' }}>
                                <a href='https://ujdml.co.za/' style={{ textDecoration: 'none' }}>
                                  <span
                                    style={{
                                      color: '#57575a',
                                      fontSize: '22px'
                                    }}
                                  >
                                    <strong>UJ Digital Media Library</strong>
                                  </span>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </body>
    </html>
  )
}

function renderBody() {
 return type === 'reject' ?
   (
    <td style={{ fontSize: '14px', padding: '20px 20px 20px 20px' }}>
      <p>{`Dear ${reportedData.reportedBy},`}</p>
      <p>
        {`You have reported a `}
        <span>
          <a href={`https://ujdml.co.za/photos/${photo.id}`} style={{ color: '#57575a' }}>photo</a>
        </span>
        {` on the UJ Digital Media Library. The deletion request was rejected by the administrator for the following reason: `}
      </p>
      <p>{`"${reason}"`}</p>
      <p>{`If you still feel that this request should be considered, please contact the administrator directly at `}
      <span><a href={`mailto:${rejectedBy}`} style={{ color: '#57575a' }}>{rejectedBy}</a></span>
      </p>
    </td>
  ) :
  (
    <td style={{ fontSize: '14px', padding: '20px 20px 20px 20px' }}>
    <p>{`Dear ${reportedData.reportedBy},`}</p>
    <p>
      {`You have reported a photo on the UJ Digital Media Library. The deletion request was approved by the administrator and the photo has been deleted.`}
    </p>
  </td>
  )
}

function createToRecipientList() {
  const recipients = [{
      emailAddress: {
        address: reportedData.email
      }
    }]
  return recipients
}

var retries = 0
async function sendMailViaCloudFunction() {
  await functions
    .httpsCallable('sendMail')({
      toRecipients,
      ccRecipients: null,
      subject,
      messageContent
    })
    .then(() => 'SUCCESS')
    .catch(async error => {
      if (retries < 10) {
        retries++
        setTimeout(async () => {
          return await sendMailViaCloudFunction()
        }, 500)
      } else {
        store.dispatch(setError(error, false, 'Failed to send email in Admin component.'))
      }
    })
}

export default sendEmail
